
import React, { useRef, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { DollarSign, MessageSquare, FileText } from 'lucide-react';
import TalkToSales from './TalkToSales';

const ContactSalesSection: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const elements = entry.target.querySelectorAll('.animate-on-scroll');
            elements.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add('visible');
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="section-padding bg-gradient-to-b from-white to-gray-50">
      <div className="container max-w-5xl">
        <Card className="shadow-md overflow-hidden border-0">
          <CardContent className="p-0">
            <div className="grid md:grid-cols-12 gap-0">
              {/* Left Section - Icons */}
              <div className="md:col-span-4 bg-[#F5F3FF] p-8 flex flex-col items-center justify-center space-y-6">
                <div className="animate-on-scroll">
                  <div className="flex space-x-2">
                    <div className="bg-blue-100 p-4 rounded-full">
                      <DollarSign className="h-6 w-6 text-blue-500" />
                    </div>
                    <div className="bg-yellow-100 p-4 rounded-full">
                      <MessageSquare className="h-6 w-6 text-yellow-500" />
                    </div>
                  </div>
                </div>
                <div className="animate-on-scroll mt-4">
                  <div className="bg-primary-100 p-4 rounded-full">
                    <FileText className="h-6 w-6 text-primary" />
                  </div>
                </div>
              </div>

              {/* Right Section - Content */}
              <div className="md:col-span-8 p-8 flex flex-col justify-center">
                <h2 className="text-2xl md:text-3xl font-bold mb-4 animate-on-scroll">
                  Have more advanced needs?
                </h2>
                <p className="text-neutral-600 mb-6 animate-on-scroll">
                  Contact our team for enterprise pricing, custom integrations,
                  white-label solutions, or specific industry use cases.
                </p>
                <div className="animate-on-scroll">
                  <TalkToSales />
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ContactSalesSection;
